import "../pages.scss"
import { SucursalesState } from '../../context/sucursales/SucursalesState';
import Datatable from "./sucursalesTable/Datatable"

const SucursalesPage = () => {
  return (
    <>
      <SucursalesState>
        <Datatable />
      </SucursalesState>

    </>
  )
}

export default SucursalesPage